import { dbPromise } from "./index";
import { decryptMyData, encryptMyData } from "../utility/Utils";

export async function dbInsertAllData(dbName, dbVersion, storeName, data) {
  const db = await dbPromise(dbName, dbVersion, storeName);
  const tx = db.transaction(storeName, "readwrite");
  const store = tx.objectStore(storeName);
  await store.add({ id: 1, data: encryptMyData(data) });
  await tx.complete;
}

export async function dbGetAllData(dbName, dbVersion, storeName, key) {
  const db = await dbPromise(dbName, dbVersion, storeName, key);
  const tx = db.transaction(storeName, "readonly");
  const store = tx.objectStore(storeName);
  const data = await store.getAll();
  await tx.complete;
  return data.length == 0 ? [] : decryptMyData(data[0]?.data);
}

export async function dbInsert(dbName, dbVersion, storeName, key, data, order) {
  const db = await dbPromise(dbName, dbVersion, storeName, key);
  const tx = db.transaction(storeName, "readwrite");
  const store = tx.objectStore(storeName);
  let dbData = await store.getAll();
  if (dbData.length > 0) {
    let decryptData = decryptMyData(dbData[0]?.data);
    order == undefined
      ? decryptData.unshift(data)
      : order == "asc"
      ? decryptData.push(data)
      : order == "des"
      ? decryptData.unshift(data)
      : decryptData.unshift(data);
    let newDbData = { id: 1, data: encryptMyData(decryptData) };
    await store.put(newDbData);
    await tx.complete;
  }
}

export async function dbUpdateData(
  dbName,
  dbVersion,
  storeName,
  key,
  ObjKey,
  data
) {
  const db = await dbPromise(dbName, dbVersion, storeName, key);
  const tx = db.transaction(storeName, "readwrite");
  const store = tx.objectStore(storeName);
  let dbData = await store.getAll();
  if (dbData.length > 0) {
    let decryptData = decryptMyData(dbData[0]?.data);
    let updatedData = decryptData.map((obj) => {
      return obj[ObjKey] == data[ObjKey] ? (obj = data) : obj;
    });
    let newDbData = { id: 1, data: encryptMyData(updatedData) };
    await store.put(newDbData);
    await tx.complete;
  }
}

export async function dbDeleteData(
  dbName,
  dbVersion,
  storeName,
  key,
  ObjKey,
  id
) {
  const db = await dbPromise(dbName, dbVersion, storeName, key);
  const tx = db.transaction(storeName, "readwrite");
  const store = tx.objectStore(storeName);
  let dbData = await store.getAll();
  if (dbData.length > 0) {
    let decryptData = decryptMyData(dbData[0]?.data);
    let updatedData = decryptData.filter((obj) => {
      return obj[ObjKey] != id;
    });
    let newDbData = { id: 1, data: encryptMyData(updatedData) };
    await store.put(newDbData);
    await tx.complete;
  }
}

export const clearIndexedDB = async () => {
  const idb = window.indexedDB;
  const databases = await idb.databases();
  for (const database of databases) {
    await idb.deleteDatabase(database.name);
  }
};
